import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Activity, AlertTriangle } from 'lucide-react';

/**
 * Compact ASR (Whisper) health indicator for the admin header.
 * Makes a silent key exhaustion (credit / rate-limit) immediately visible.
 */
export const AdminAsrHealthBadge = ({ backendUrl, token }) => {
  const [h, setH] = useState(null);

  const load = useCallback(async () => {
    try {
      const res = await axios.get(`${backendUrl}/api/level-test/admin/asr-health`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setH(res.data);
    } catch { /* ignore */ }
  }, [backendUrl, token]);

  useEffect(() => {
    load();
    const id = setInterval(load, 60000);
    return () => clearInterval(id);
  }, [load]);

  if (!h) return null;

  const degraded = h.status === 'degraded';
  const fmt = (iso) => (iso ? new Date(iso).toLocaleString('it-IT', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—');

  return (
    <div
      data-testid="admin-asr-health"
      title={`Ultimo successo: ${fmt(h.last_success)} · Ultimo fallimento: ${fmt(h.last_failure)}`}
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full border text-xs font-bold ${
        degraded
          ? 'border-rose-500/50 bg-rose-500/15 text-rose-200'
          : 'border-emerald-500/40 bg-emerald-500/10 text-emerald-200'
      }`}
    >
      {degraded ? <AlertTriangle className="w-3.5 h-3.5" /> : <Activity className="w-3.5 h-3.5" />}
      <span data-testid="admin-asr-health-status">
        ASR {degraded ? 'DEGRADATO' : 'ok'}
      </span>
      {!h.configured && <span className="text-slate-400 font-normal">(chiave non configurata)</span>}
      {h.failures_24h > 0 && (
        <span className="text-rose-300 font-normal" data-testid="admin-asr-health-24h">· {h.failures_24h} fail/24h</span>
      )}
    </div>
  );
};

export default AdminAsrHealthBadge;
